import * as React from 'react';
var SvgFingerPoint = () => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.5 18.25c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25v.5ZM9.75 20A1.75 1.75 0 0 1 8 18.25v-.5c0-.966.784-1.75 1.75-1.75h8.5c.967 0 1.75.784 1.75 1.75v.5A1.75 1.75 0 0 1 18.25 20h-8.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.17 12.685c-.54 1.08.32 2.25 1.399 2.293L4.17 12.685Zm1.357.729c.03.045.071.064.102.066.847.034 1.999.162 2.963.59.8.353 1.554.96 1.813 1.93h7.17a.25.25 0 0 0 .247-.213l.578-3.9a1.25 1.25 0 0 0-1.064-1.422l-5.19-.722A.75.75 0 0 1 11.5 9V6a.5.5 0 1 0-1 0v5.75a.75.75 0 0 1-.75.75H6.897c-.586 0-1.123.331-1.385.856a.02.02 0 0 0-.002.013c0 .008.004.024.017.045Zm-1.356-.729A3.048 3.048 0 0 1 6.897 11H9V6a2 2 0 1 1 4 0v2.347l4.542.632a2.75 2.75 0 0 1 2.342 3.127l-.578 3.9a1.75 1.75 0 0 1-1.731 1.494H9.75a.75.75 0 0 1-.75-.75c0-.607-.338-1.01-1.016-1.31-.702-.31-1.627-.43-2.415-.462",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.249 7.55a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75Z",
  fill: "currentColor"
}));
export default SvgFingerPoint;